import React from 'react';
import { cn } from '../../classname';
import './Form.css';
const b = cn('form');
export const Form = ({ className, children }) => {
    return React.createElement("div", { className: b(null, [className]) }, children);
};
